import { Component, OnInit } from '@angular/core';
import { ModalBase, notification, color, language } from 'curvy';
import { Task } from '@task-utils/types';
import { User } from '@task-modules/users';
import { TaskRoutes } from '@task-utils/routes';



type UserType = Pick<Task.User, 'first_name' | 'last_name' | 'email' | 'contact_phone' | 'is_student' | 'institution' | 'user_type_id'>;


@Component({
   selector: 'task-create-edit-external-worker-dialog',
   template: `
      <task-create-edit-external-worker [user]="user" (result)="handle_result($event)"></task-create-edit-external-worker>
   `
})
export class CreateEditExternalWorkerDialog extends ModalBase<UserType | Promise<UserType>, boolean> implements OnInit {
   preventSoftClose = true;
   user: UserType;

   ngOnInit() {
      if (this.injectedData instanceof Promise) {
         this.injectedData.then(res => {
            this.user = res || {
               first_name: "",
               last_name: "",
               email: "",
               contact_phone: "",
               is_student: false,
               institution: "",
               user_type_id: Task.USER_TYPE.EXTERNAL_WORKER,
            }
         });
      }else {
         this.user = this.injectedData || {
            first_name: "",
            last_name: "",
            email: "",
            contact_phone: "",
            is_student: false,
            institution: "",
            user_type_id: Task.USER_TYPE.EXTERNAL_WORKER,
         }
      }
   }

   handle_result(user: UserType) {
      if (user == null) {
         this.submit(false);
         return;
      }

      this.user = user;
      let promise: Promise<any>;

      if (this.user["user_id"]) {
         promise = TaskRoutes.users.api_user_modify((this.user as Task.User).user_id, this.user);
      } else {
         promise = TaskRoutes.users.api_user_add(this.user);
      }

      promise.then(()=>{
         this.submit(true);
      }).catch(err=>{
         if (!this.user["user_id"]) {
            switch (err.internal_error_code) {
               case 4003:
                  notification.show({
                     message: language.translate("ERROR.USER_EXISTS_TEXT"),
                     title: language.translate("ERROR"),
                     color: color.Variable.warn,
                     icon: "error",
                     timeout: 0
                  })
                  break;
               default:
                  notification.show({
                     message: language.translate("ERROR.USER_GENERIC_TEXT"),
                     title: language.translate("ERROR"),
                     color: color.Variable.warn,
                     icon: "error"
                  })
                  break;
               }
            }
      });
   }
}